export default "__VITE_ASSET__DFzwRy3C__"